<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-shopping-cart" /> Vendas e Orçamentos
        </h2>
        <small class="text-muted">Gerencie produtos, preços e estoques.</small>
      </div>
      <div class="col-md-6 col-sm-12 text-md-right mt-3">
        <router-link
          v-if="orderCreateEdit"
          class="btn btn-success"
          to="/vendas/venda/novo"
        >
          <i class="fas fa-plus" /> Nova Venda
        </router-link>

        <router-link
          v-if="canManagerSettings"
          class="btn btn-primary ml-2"
          to="/comissao"
        >
          <i class="fas fa-user-tie"></i> Comissão
        </router-link>
        <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
          <template v-if="$acl.can('orderReport')">
            <b-dropdown-item @click="printReport()"
              ><i class="fas fa-print mr-2" />Imprimir Relatório
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="printReportOrderOfProductsBySalesman()"
              ><i class="fas fa-print mr-2" />Venda de Produtos por Vendedor
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
          </template>
          <b-dropdown-item
            v-if="canManagerSettings"
            @click="OrderSettingsForm()"
          >
            <i class="fas fa-cog" mr-2 />
            Configurações de Vendas
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <br />

    <collapse-of-the-order-filter v-model="form" @filter="select($event)" />

    <br />
    <b-row>
      <b-col cols="12" md="12">
        <order-list
          class="d-md-block d-none px-0"
          :orders="order"
          :status="status"
          @PrintOrder="printOrder($event)"
          @EmitOrderBill="emitOrderBillForm($event)"
          @emitMovimentStock="emitOrderMovimentStockform($event)"
          @CancelOrder="orderCancelform($event)"
          @emitNfe="onEmitNfe($event)"
          @pagechange="select($event)"
        />
        <order-list-mobile
          class="d-md-none"
          :orders="order"
          :status="status"
          @PrintOrder="printOrder($event)"
          @EmitOrderBill="emitOrderBillForm($event)"
          @emitMovimentStock="emitOrderMovimentStockform($event)"
          @CancelOrder="orderCancelform($event)"
          @emitNfe="onEmitNfe($event)"
          @pagechange="select($event)"
        />
      </b-col>
    </b-row>

    <emit-order-bill-form ref="emitOrderBillForm" @stored="select" />
    <emit-nfe-from-order-form ref="emitNfeFromOrderForm" @stored="select" />
    <order-cancel-form ref="orderCancelform" @stored="select" />
    <order-printer ref="orderPrinter" />
    <order-confirmed-form ref="orderConfirmedForm" />
    <emit-order-moviment-stock-form
      ref="emitOrderMovimentStockForm"
      @stored="select"
    />
    <order-settings-form ref="orderSettingsForm" />
    <error-handler :error="error" />
  </div>
</template>

<script>
import OrderFilter from "@/components/sections/order/OrderFilter.vue";
// import Filters from "./../../mixins/Filters";
import TablePaginator from "./../../components/sections/TablePaginator.vue";
// import VueRouter from "./../../router";
import Avatar from "vue-avatar";
import EmitOrderBillForm from "./../../components/forms/EmitOrderBillForm.vue";
import EmitNfeFromOrderForm from "./../../components/forms/order/EmitNfeFromOrderForm.vue";
// import moment from "moment";
import OrderCancelForm from "./../../components/forms/OrderCancelForm.vue";
import OrderPrinter from "./../../components/printers/OrderPrinter.vue";
import orderConfirmedForm from "./../../components/forms/OrderConfirmedForm.vue";
import EmitOrderMovimentStockForm from "./../../components/forms/EmitOrderMovimentStockForm.vue";
import OrderList from "./../../components/lists/OrderList.vue";
import OrderSettingsForm from "./../../components/forms/OrderSettingsForm.vue";
import CollapseOfTheOrderFilter from "./../../components/Filter/CollapseOfTheOrderFilter";
import OrderListMobile from "@/components/lists/OrderListMobile";

export default {
  components: {
    TablePaginator,
    Avatar,
    EmitOrderBillForm,
    EmitNfeFromOrderForm,
    EmitOrderMovimentStockForm,
    OrderSettingsForm,
    OrderCancelForm,
    OrderFilter,
    OrderPrinter,
    orderConfirmedForm,
    OrderList,
    CollapseOfTheOrderFilter,
    OrderListMobile,
  },

  data: function () {
    return {
      order: {
        data: null,
      },

      //   searchForm: {
      //     name: null,
      //     saved_at_start: null,
      //     saved_at_end: null,
      //     status: ["d", "p", "o", ""],
      //     finance_status: {},
      //   },

      error: null,
      form: {},
      status: {
        d: {
          text: "Rascunho",
          class: "badge-secondary",
          value: "0",
        },

        p: {
          text: "OrÃ§amento",
          class: "badge-primary",
        },

        o: {
          text: "Venda",
          class: "badge-success",
        },

        c: {
          text: "Cancelada",
          class: "badge-danger",
        },
      },

      finance_status: {
        1: {
          text: "Financeiro",
          class: "badge-success",
          value: "0",
        },

        0: {
          text: "Financeiro",
          class: "badge-warning",
        },
      },

      error: null,
    };
  },

  computed: {
    enabledStock() {
      if (this.$store.state.company.module_stock_active == 1) {
        return true;
      }
    },

    canManagerSettings() {
      if (!this.$store.state.user) {
        return false;
      }

      if (
        this.$store.state.user.is_master_user != 1 &&
        this.$store.state.user.is_admin_user != 1
      ) {
        return false;
      }

      return true;
    },

    hasModuleNfe() {
      if (!this.$store.state.company) {
        return false;
      }

      if (this.$store.state.company.module_nfe_active != 1) {
        return false;
      }

      return true;
    },

    orderCreateEdit() {
      return this.$acl.can("orderCreateEdit");
    },
  },

  mounted() {
    axios
      .post("api/order/select")
      .then((response) => {
        this.order = response.data.orders;

        this.$store.commit("pageHasLoaded");
      })
      .catch((error) => {
        this.error = error;
      });
  },

  methods: {
    onEmitNfe(event) {
      if (this.hasModuleNfe) {
        this.$refs.emitNfeFromOrderForm.open(
          event.id,
          event.value_nf,
          event.model
        );
      }
    },

    getSumByPaymentMethod(paymentMethod) {
      if (!this.sumByPaymentMethod[paymentMethod]) {
        return 0;
      }

      return this.sumByPaymentMethod[paymentMethod].sum_net_total;
    },

    orderConfirmedForm(id) {
      if (this.$acl.can("orderCreateEdit")) {
        this.$refs.orderConfirmedForm.open(id);
      }
    },

    emitOrderBillForm(id) {
      this.$refs.emitOrderBillForm.open(id);
    },

    emitOrderMovimentStockform(id) {
      if (this.$acl.can("orderCreateEdit")) {
        this.$refs.emitOrderMovimentStockForm.open(id);
      }
    },

    orderCancelform(order) {
      if (this.$acl.can("orderCancel")) {
        this.$refs.orderCancelform.open(order);
      }
    },

    select(page = 1) {
      this.$store.commit("showLoading");

      axios
        .post("api/order/select?page=" + page, this.form)
        .then((response) => {
          this.order = response.data.orders;

          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");

          this.error = error;
        });
    },

    printOrder(order) {
      window.open("/vendas/imprimir/cupom/" + order.id, "_blank");
    },

    OrderSettingsForm() {
      this.$refs.orderSettingsForm.open();
    },
    printReport() {
      window.open("/vendas/relatorio");
    },
    printReportOrderOfProductsBySalesman() {
      window.open("vendas/relatorio/venda-de-produtos-por-vendedor");
    },
  },
};
</script>
